import { View, Text, TouchableOpacity } from "react-native";
import React, { useState } from "react";

import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";

import { Ionicons } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";

import { useScreenDimensions, useDevice } from "../_layout";

import { useTranslation } from "react-i18next";

const TracCalendarButton = ({ trac }) => {
  const { t } = useTranslation();

  function formatNumber(num) {
    return parseFloat(num.toFixed(2)).toString();
  }
  const { screenSize } = useScreenDimensions();
  return (
    <View style={[GlobalStyles.touchableRow, {}]}>
      <View
        style={[
          GlobalStyles.calendarRow,
          {
            flex: 1,
            flexWrap: "wrap",
            alignItems: "flex-start",
          },
        ]}
      >
        <View style={{ alignItems: "flex-start", flex: 1 }}>
          <View style={GlobalStyles.HStack}>
            <Text
              style={[
                Fonts.bold18,
                {
                  paddingBottom: 8,
                  flexShrink: 1,
                },
              ]}
            >
              Trac
            </Text>
          </View>
          <View
            style={[
              GlobalStyles.HStack,
              {
                flexWrap: "wrap",
                flex: 1,
                rowGap: 0,
              },
            ]}
          >
            <View style={[GlobalStyles.HStack, { flexShrink: 1 }]}>
              <Ionicons
                name="person"
                size={12}
                color={Colors.tracColor}
                style={GlobalStyles.rowIcon}
              />
              <Text style={{ ...GlobalStyles.rowSubText, marginRight: 0 }}>
                {t("todayTrac-string", {
                  count:
                    trac.motivation +
                    trac.perceivedRecovery +
                    trac.technicalComfort +
                    trac.sleepQualityNutrition,
                })}
              </Text>
            </View>
          </View>
        </View>
        <View style={GlobalStyles.Spacer} />
      </View>
    </View>
  );
};

export default TracCalendarButton;
